// extracted by mini-css-extract-plugin
export default {"login-container":"style_login-container__R2Tny","image":"style_image__gR9MP","loginBox":"style_loginBox__DMo0A","errorBox":"style_errorBox__AVhV2"};